module.exports = __webpack_public_path__ + "img/smiths.d035a500.png";